import _ from 'lodash'
import anime from 'animejs'
import { point as turfPoint } from '@turf/helpers'
import { lineString as turfLineString } from '@turf/helpers'
import turfDistance from '@turf/distance'
import turfAlong from '@turf/along'
import { throws } from 'assert'
import utils from '../../utils'

export default class OverlayView extends google.maps.OverlayView {

    constructor(map, position){
        super()
        // Initialize all properties.
        if (typeof draw === 'function'){
            this.draw = draw;
        }
        this.setValues({
            position: position,
            container: null,
            content: `<div class="marker-avatar" style="visibility: hidden;">
            <img style="border-radius: 50%; border: 2px solid #FFF; width: 32px; height: 32px;" 
            class="marker-img" 
            src="${require('../../assets/imgs/default-avatar.png')}"/>
            <span class="marker-avatar__label"></span>
            </div>`,
            map: map
        })
        this._initialPositions = []
    }

    onAdd(){
        const container = document.createElement('div')
        container.classList.add("marker-avatar-container")

        if (typeof this.get('content').nodeName !== 'undefined') {
            container.appendChild(this.get('content'));
        } else {
            if (typeof this.get('content') === 'string') {
                container.innerHTML = this.get('content');
            } else {
                return;
            }
        }
        container.style.position = 'absolute';
        container.draggable = true;

        this.set('container', container)
        this.getPanes().floatPane.appendChild(container);
    }

    onRemove(){
        this.get('container').parentNode.removeChild(this.get('container'))
        this.set('container', null)
    }

    async draw(){
        const pos = this.getProjection().fromLatLngToDivPixel(this.get('position'))
        this.get('container').style.left = pos.x + 'px'
        this.get('container').style.top = pos.y + 'px'
    }

    waitForGetProjection(){
        const vm = this
        return new Promise((resolve) => {
            (function r(){
                if(vm.getProjection() && vm.get('container')){
                    return resolve(vm.getProjection())
                }
                setTimeout(async () => {
                    await r()
                }, 50)
            })()
        })
        
    }

    async setVisible(visible){
        await this.waitForGetProjection()
        this.get('container').getElementsByClassName("marker-avatar")[0].style.visibility = (visible) ? "visible" : "hidden"
    }

    async setColor(color){
        await this.waitForGetProjection()
        const markerImg = this.get('container').getElementsByClassName("marker-img")[0]
        markerImg.style.borderColor = color
    }

    async setAvatar(imgLink){
        await this.waitForGetProjection()
        const markerImg = this.get('container').getElementsByClassName("marker-img")[0]
        markerImg.src = imgLink
    }

    async setLabel(label, color="#000000"){
        await this.waitForGetProjection()
        const markerLabel = this.get('container').getElementsByClassName("marker-avatar__label")[0]
        markerLabel.innerHTML = label
        //markerLabel.style.textShadow = `0px 0px 2px ${color}, 0px 0px 2px ${color}, 0px 0px 2px ${color}, 0px 0px 3px ${color}, 0px 0px 4px ${color}, 0px 0px 5px ${color}, 0px 0px 5px ${color}, 0px 0px 5px ${color}`
        markerLabel.style.color = utils.getLighterColor(color,50)
    }

    async setToPosition(args){
        let latLng = null
        if(args.length === 1) latLng = args[0]
        else latLng = new google.maps.LatLng(
            args[0],
            args[1]
        )
        this._initialPositions.push(latLng)
        if(this._initialPositions.length) return
        const projection = await this.waitForGetProjection()
        const pos = projection.fromLatLngToDivPixel(_.last(this._initialPositions))
        this.get('container').style.left = pos.x + 'px'
        this.get('container').style.top = pos.y + 'px'
        this.setValues({
            position: latLng,
        })
    }

    getCurrentPosition(){
        return this.get('position')
    }

    async animateToPosition(lat,lng,options = {}){
        const projection = await this.waitForGetProjection()

        const defaultOptions = {
            duration: 500,
            animation: "easeInOutCirc"
        }
        options = _.assign(defaultOptions, options)

        const vm = this
        const initialLat = this.get('position').lat()
        const initialLng = this.get('position').lng()
        const initialPoint = turfPoint([initialLat,initialLng])
        const destinationLat = lat
        const destinationLng = lng
        const destinationPoint = turfPoint([destinationLat,destinationLng])
        const distanceInMeters = parseInt(turfDistance(initialPoint,destinationPoint,{
            units: 'meters'
        }))
        const pos = projection.fromLatLngToDivPixel(this.get('position'))
        this.get('container').style.left = pos.x + 'px'
        this.get('container').style.top = pos.y + 'px'
        let animation = { cycles: 0 }
        const lineString = turfLineString([[initialLat,initialLng],[destinationLat,destinationLng]])
        let perc = 0
        anime({
            targets: animation,
            cycles: 100,
            round: 10,
            easing: options.animation,
            duration: options.duration,
            update: function() {
                perc = distanceInMeters * (animation.cycles / 100)
                const along = turfAlong(lineString, perc, {
                    units: 'meters'
                })
                const currentAnimationLatLng = new google.maps.LatLng(along.geometry.coordinates[0],along.geometry.coordinates[1])
                const pos = projection.fromLatLngToDivPixel(currentAnimationLatLng)
                vm.get('container').style.left = pos.x + 'px'
                vm.get('container').style.top = pos.y + 'px'
                vm.setValues({
                    position: currentAnimationLatLng,
                })
            }
        })
    }

    verifyInitialized(){
        const projection = this.getProjection()
        if(projection){
            console.log("toReturn",projection)
            return projection
        }
        setTimeout(async () => {
            await this.verifyInitialized()
        }, 50)
    }
}